<div class="page-title mb-2">
  <div class="row">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
      <h4>Dashboard</h4>
    </div>
  </div>
</div>

<div class="card">
  <div class="card-header">Title</div>
  <div class="card-body">
    <h5 class="card-title">Special title</h5>
    <p class="card-text">Description</p>
  </div>
</div>
